module.exports = __webpack_public_path__ + "static/media/trimex_grano de plata.b5e8f4fc.png";